/**
 * Global JavaScript for SystemicLifeCo Theme
 */
(function() {
  'use strict';

  function initMobileMenu() {
    var menuToggle = document.querySelector('.header__menu-toggle');
    var mobileMenu = document.getElementById('mobile-menu');
    var mobileClose = document.querySelector('.header__mobile-close');
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        mobileMenu.classList.toggle('is-active');
        document.body.style.overflow = mobileMenu.classList.contains('is-active') ? 'hidden' : '';
      });
    }
    if (mobileClose && mobileMenu) {
      mobileClose.addEventListener('click', function() {
        mobileMenu.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    }
  }

  function initSearch() {
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchClose = document.querySelector('[data-search-close]');
    var searchPanel = document.getElementById('header-search');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function() {
        searchPanel.classList.toggle('is-active');
        if (searchPanel.classList.contains('is-active')) {
          searchPanel.querySelector('input').focus();
        }
      });
    }
    if (searchClose && searchPanel) {
      searchClose.addEventListener('click', function() {
        searchPanel.classList.remove('is-active');
      });
    }
  }

  function initAccordions() {
    document.querySelectorAll('.accordion__content').forEach(function(el) {
      el.style.display = 'none';
    });
    document.querySelectorAll('.accordion__trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = this.parentElement;
        var content = this.nextElementSibling;
        var isActive = item.classList.contains('is-active');
        item.closest('.accordion').querySelectorAll('.accordion__item').forEach(function(el) {
          el.classList.remove('is-active');
          el.querySelector('.accordion__content').style.display = 'none';
        });
        if (!isActive) {
          item.classList.add('is-active');
          content.style.display = 'block';
        }
      });
    });
  }

  function initProductGallery() {
    var thumbs = document.querySelectorAll('.product__thumb');
    var mainImage = document.getElementById('ProductMainImage');
    if (thumbs.length && mainImage) {
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          this.classList.add('is-active');
          if (this.dataset.image) {
            mainImage.src = this.dataset.image;
            mainImage.alt = this.dataset.alt || '';
          }
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initMobileMenu();
    initSearch();
    initAccordions();
    initProductGallery();
  });
})();
